import HttpService from "../http";

const AuthService = () => {
  const { httpRequest, httpFormRequest } = HttpService();

  const sendOtp = (payload) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/auth/send_otp", payload)
        .then(resolve)
        .catch(reject);
    });

  const verifyOtp = (payload) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/auth/otp_verify", payload)
        .then(resolve)
        .catch(reject);
    });

  const login = (payload) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/auth/login", payload)
        .then(resolve)
        .catch(reject);
    });

  const addUser = (payload) =>
    new Promise((resolve, reject) => {
      httpFormRequest("POST", "user/v1/auth/register", payload)
        .then(resolve)
        .catch(reject);
    });

  const resetPassword = (payload) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/auth/reset_password", payload)
        .then(resolve)
        .catch(reject);
    });

  const queryApi = (payload) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/settings/submit_query", payload)
        .then(resolve)
        .catch(reject);
    });

  return { sendOtp, resetPassword, verifyOtp, login, addUser, queryApi };
};

export { AuthService };
